import React, { useEffect } from 'react'

import {
  GlobalContext,
  useGlobalReducer,
  languageChanged,
  loggerBefore,
  loggerAfter
} from './state'
import { Map, SideBar, Header, SideBarRight, Typographys } from './components'

const validLanguages = ['es', 'en']

export const App = () => {
  const [state, dispatch] = useGlobalReducer()
  // const [state, dispatch] = useGlobalReducer([loggerBefore], [loggerAfter])

  const provider = {
    state,
    dispatch
  }

  const params = new URLSearchParams(window.location.search)
  const showTypographys = !!params.get('typographys')

  useEffect(
    () => {
      const lang = params.get('lang')
      const language = validLanguages.includes(lang) ? lang : validLanguages[0]
      dispatch(languageChanged(language))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  return (
    <GlobalContext.Provider value={provider}>
      <Header />
      <SideBar />
      <Map />
      {showTypographys ? <Typographys /> : <SideBarRight />}
    </GlobalContext.Provider>
  )
}
